import { render, staticRenderFns } from "./SharingForm.vue?vue&type=template&id=c9412150&"
import script from "./SharingForm.vue?vue&type=script&lang=js&"
export * from "./SharingForm.vue?vue&type=script&lang=js&"
import style0 from "./SharingForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports